import { certificationTypeNameDefinitions } from '../constants';

export const certificationTypeShortNameMap = {
  MOVE_IN: 'MI',
  RECERT: 'AR',
  RECERT_UT: 'AR/UT',
  INITIAL: 'IC',
  INITIAL_UT: 'IC/UT',
  INTERIM: 'IR',
  INTERIM_UT: 'IR/UT',
  CORRECTION: 'Correction',
  TERMINATION: 'TM',
  MOVE_OUT: 'MO',
  GROSS_RENT: 'GR',
  UNIT_TRANSFER: 'UT',
  MODIFY: 'M',
};

export const RDCertificationTypeShortNameMap = {
  INITIAL: certificationTypeNameDefinitions.MOVE_IN_RD,
  INITIAL_UT: certificationTypeNameDefinitions.MOVE_IN_RD,
  MOVE_IN: certificationTypeNameDefinitions.MOVE_IN_RD,
  RECERT: certificationTypeNameDefinitions.RECERT,
  RECERT_UT: certificationTypeNameDefinitions.RECERT,
  CO_TENANT_TO_TENANT: certificationTypeNameDefinitions.CO_TENANT_TO_TENANT,
  TERMINATE_ABSENCE: certificationTypeNameDefinitions.TERMINATE_ABSENCE,
  INITIATE_ABSENCE: certificationTypeNameDefinitions.INITIATE_ABSENCE,
  EVICTION: certificationTypeNameDefinitions.EVICTION,
  VACATE: certificationTypeNameDefinitions.VACATE,
  ASSIGN_REMOVE_RA: certificationTypeNameDefinitions.ASSIGN_REMOVE_RA,
  UNIT_TRANSFER: certificationTypeNameDefinitions.RD_UNIT_TRANSFER,
  MODIFY: certificationTypeNameDefinitions.MODIFY,
  GROSS_RENT: certificationTypeNameDefinitions.GROSS_RENT,
};

// return a JSON prop key to be used to reference intl.messages object
export const LIHTCCertificationTypeMap = {
  INITIAL: 'initialCertification',
  INITIAL_UT: 'initialCertification',
  MOVE_IN: 'moveInCertification',
  RECERT: 'recert',
  RECERT_UT: 'recert',
  INTERIM: 'interim',
  INTERIM_UT: 'interim',
  UNIT_TRANSFER: 'unitTransfer',
};

export const HUD_PROGRAM_NAME = 'HUD';

export const TAB_INDEX = {
  STARTED: 0,
  REOPENED: 1,
  COMPLETED: 2,
};

/** Maps numeric tab index to component-library `CertificationStatus` strings. */
export const TAB_STATUS = {
  [TAB_INDEX.STARTED]: 'STARTED',
  [TAB_INDEX.REOPENED]: 'REOPENED',
  [TAB_INDEX.COMPLETED]: 'COMPLETED',
};
